"use strict";
exports.__esModule = true;
var angular = require("angular");
var filter_logic_1 = require("../filter-logic");
require('./simple-filter-v2.component.css');
require('./searchable-multiselect.css');
var COMPONENT_NAME = 'smartorg.r6.reportOptions.simpleFilterV2';
var SimpleFilterV2Component = /** @class */ (function () {
    function SimpleFilterV2Component() {
        this.filterQuery = '';
        this.filterList = [];
        this.dropdownTagsMap = {};
        this.selectedTags = [];
        this.excludedTags = [];
        this.resetSearchQuery();
        // this.origInvertFilterFlag = angular.copy(this.invertFilter);
    }
    SimpleFilterV2Component.prototype.$onChanges = function (changesObj) {
        var _this = this;
        // console.log('Advanced', changesObj);
        if ((changesObj.allTags || changesObj.allDropdownTags) && (this.allTags || this.allDropdownTags)) {
            this.allValidTags = (this.allTags || []).filter(function (t) { return t.includes(':'); });
            if (!this.allDropdownTags) {
                return;
            }
            for (var _i = 0, _a = this.allDropdownTags; _i < _a.length; _i++) {
                var t = _a[_i];
                if (t.split(':').length !== 3) {
                    continue;
                }
                var _b = t.split(':'), key = _b[0], codedValue = _b[1], codedName = _b[2];
                var tagForSelect = atob(decodeURIComponent(codedName)) + ':' + atob(decodeURIComponent(codedValue));
                this.allValidTags.push(tagForSelect);
                this.dropdownTagsMap[tagForSelect] = t;
            }
        }
        var filterLogic = filter_logic_1.createFilterLogic(this.initState);
        this.parseSimpleFilterFromString(filterLogic);
        this.makeSelectedTags();
        this.excludedTags = this.initExcludedFilterTags ? angular.copy(this.initExcludedFilterTags) : [];
        this.validTagsWithoutExcluded = [];
        this.validTagsWithoutSelected = [];
        if (this.allValidTags) {
            this.allValidTags.forEach(function (tag) {
                if (_this.excludedTags.indexOf(tag) == -1) {
                    _this.validTagsWithoutExcluded.push(tag);
                }
            });
            this.allValidTags.forEach(function (tag) {
                if (_this.selectedTags.indexOf(tag) == -1) {
                    _this.validTagsWithoutSelected.push(tag);
                }
            });
        }
        this.updateQuery();
    };
    SimpleFilterV2Component.prototype.parseSimpleFilterFromString = function (filterLogic) {
        if (!filterLogic) {
            this.filterList = [];
            return;
        }
        this.filterList = filterLogic.children.map(function (f) {
            if (f instanceof filter_logic_1["default"]) {
                var tags = f.children;
                if (tags[0].split(':').length === 3) {
                    var _a = tags[0].split(':'), key = _a[0], v = _a[1], codedName = _a[2];
                    var entries_1 = tags.map(function (t) { return ({ name: atob(decodeURIComponent(t.split(':')[1])), selected: true }); });
                    return { key: key, name: atob(decodeURIComponent(codedName)), entries: entries_1, isDropdown: true };
                }
                var name_1 = tags[0].split(':')[0];
                var entries = tags.map(function (t) { return ({ name: t.split(':')[1], selected: true }); });
                return { name: name_1, entries: entries };
            }
            else {
                var filterStrArr = f.split(':');
                if (filterStrArr.length === 3) {
                    var key = filterStrArr[0], codedVal = filterStrArr[1], codedName = filterStrArr[2];
                    return { key: key, entries: [{ name: atob(decodeURIComponent(codedVal)), selected: true }],
                        name: atob(decodeURIComponent(codedName)), isDropdown: true };
                }
                var name_2 = filterStrArr[0], entry = filterStrArr[1];
                return { name: name_2, entries: [{ name: entry, selected: true }] };
            }
        });
        this.makeSelectedTags();
    };
    SimpleFilterV2Component.prototype.makeSelectedTags = function () {
        var _this = this;
        this.selectedTags = [];
        this.filterList.forEach(function (category) {
            var categoryName = category['name'];
            if ('entries' in category) {
                category['entries'].forEach(function (categoryEntry) {
                    if ('selected' in categoryEntry
                        && 'name' in categoryEntry
                        && categoryEntry['selected'] == true) {
                        var tmpTag = categoryName + ':' + categoryEntry['name'];
                        if (_this.selectedTags.indexOf(tmpTag) == -1) {
                            _this.selectedTags.push(categoryName + ':' + categoryEntry['name']);
                        }
                    }
                });
            }
        });
    };
    SimpleFilterV2Component.prototype.verifyTag = function (tag) {
        if (!tag || !tag.includes(':')) {
            return false;
        }
        return this.allTags.some(function (t) { return t === tag; });
    };
    SimpleFilterV2Component.prototype.verifyDropdownTag = function (tag) {
        if (!tag || !tag.includes(':')) {
            return false;
        }
        var dropdownTag = this.dropdownTagsMap[tag];
        return this.allDropdownTags.some(function (t) { return t === dropdownTag; });
    };
    SimpleFilterV2Component.prototype.addTagToFilterList = function (tag) {
        if (!this.verifyTag(tag) && !this.verifyDropdownTag(tag)) {
            return;
        }
        if (tag in this.dropdownTagsMap) {
            // if (categoryName.includes('(') && categoryName.includes(')')) {
            //     const key = categoryName.split('(')[0];
            //     const name = categoryName.slice(key.length + 1, -1);
            var _a = this.dropdownTagsMap[tag].split(':'), key_1 = _a[0], codedVal_1 = _a[1], codedName = _a[2];
            if (!this.filterList.find(function (c) { return c.key && c.key === key_1; })) {
                this.filterList.push({ key: key_1, name: atob(decodeURIComponent(codedName)), entries: [], isDropdown: true });
            }
            var dropdown = this.filterList.find(function (c) { return c.key && c.key === key_1; });
            if (!dropdown.entries.find(function (en) { return en.name === atob(decodeURIComponent(codedVal_1)); })) {
                dropdown.entries.push({ name: atob(decodeURIComponent(codedVal_1)), selected: true });
            }
            this.applyChanges();
            return;
        }
        var _b = tag.split(':'), categoryName = _b[0], entry = _b[1];
        if (!this.filterList.find(function (c) { return c.name === categoryName; })) {
            this.filterList.push({ name: categoryName, entries: [] });
        }
        var category = this.filterList.find(function (c) { return c.name === categoryName; });
        if (!category.entries.find(function (en) { return en.name === entry; })) {
            category.entries.push({ name: entry, selected: true });
        }
        this.applyChanges();
    };
    SimpleFilterV2Component.prototype.addTagToExcludeList = function (tag) {
        if (this.excludedTags.indexOf(tag) == -1) {
            this.excludedTags.push(tag);
        }
        this.applyChanges();
    };
    SimpleFilterV2Component.prototype.removeTag = function (categoryIndex, entryIndex) {
        this.filterList[categoryIndex].entries.splice(entryIndex, 1);
        if (this.filterList[categoryIndex].entries.length === 0) {
            this.filterList.splice(categoryIndex, 1);
        }
        this.applyChanges();
    };
    SimpleFilterV2Component.prototype.removeCategory = function (categoryIndex) {
        this.filterList.splice(categoryIndex, 1);
        this.applyChanges();
    };
    SimpleFilterV2Component.prototype.emptyExcludedTags = function () {
        this.excludedTags = [];
        this.applyChanges();
    };
    SimpleFilterV2Component.prototype.unselectTagFromFilterList = function (tag) {
        var tmpFilterList = angular.copy(this.filterList);
        if (tag.indexOf(':') !== -1) {
            var split = tag.split(':');
            var categoryName = split[0];
            var entry = split[1];
            var entryRemoved = false;
            for (var i = 0; i < tmpFilterList.length; i++) {
                if (entryRemoved) {
                    break;
                }
                if (tmpFilterList[i]['name'] === categoryName) {
                    for (var j = 0; tmpFilterList[i]['entries'].length; j++) {
                        if (tmpFilterList[i]['entries'][j]['name'] == entry) {
                            tmpFilterList[i]['entries'].splice(j, 1);
                            entryRemoved = true;
                            if (tmpFilterList[i]['entries'].length == 0) {
                                tmpFilterList.splice(i, 1);
                            }
                            break;
                        }
                    }
                }
            }
        }
        this.filterList = angular.copy(tmpFilterList);
        this.applyChanges();
    };
    SimpleFilterV2Component.prototype.removeTagFromExcludeList = function (tag) {
        if (this.excludedTags.indexOf(tag) !== -1) {
            var idx = this.excludedTags.indexOf(tag);
            this.excludedTags.splice(idx, 1);
        }
        this.applyChanges();
    };
    SimpleFilterV2Component.prototype.updateQuery = function () {
        var filters = this.filterList.map(function (f) {
            var name = f.name, entries = f.entries, key = f.key, isDropdown = f.isDropdown;
            var tags = isDropdown ?
                entries.filter(function (en) { return en.selected; }).map(function (en) { return key + ":" + encodeURIComponent(btoa(en.name)) + ":" + encodeURIComponent(btoa(name)); }) :
                entries.filter(function (en) { return en.selected; }).map(function (en) { return name + ":" + en.name; });
            return new filter_logic_1["default"](filter_logic_1.LOGIC.OR, tags);
        });
        this.filterQuery = new filter_logic_1["default"](filter_logic_1.LOGIC.AND, filters).toExp();
    };
    SimpleFilterV2Component.prototype.applyChanges = function () {
        this.makeSelectedTags();
        this.updateQuery();
        this.updateFilter({ filterQuery: this.filterQuery, excludedTags: this.excludedTags });
    };
    SimpleFilterV2Component.prototype.resetSearchQuery = function () {
        this.searchQuery = '';
    };
    SimpleFilterV2Component.prototype.updateSelectedTags = function (tag, event) {
        event.stopPropagation();
        var selectedObj;
        for (var i = 0; typeof this.selectedTags !== 'undefined' && i < this.selectedTags.length; i++) {
            if (this.selectedTags[i].toUpperCase() === tag.toUpperCase()) {
                selectedObj = this.selectedTags[i];
                break;
            }
        }
        if (typeof selectedObj === 'undefined') {
            this.addTagToFilterList(tag);
        }
        else {
            this.unselectTagFromFilterList(tag);
        }
    };
    SimpleFilterV2Component.prototype.updateExcludedTags = function (tag, event) {
        event.stopPropagation();
        var excludedObj;
        for (var i = 0; typeof this.excludedTags !== 'undefined' && i < this.excludedTags.length; i++) {
            if (this.excludedTags[i].toUpperCase() === tag.toUpperCase()) {
                excludedObj = this.excludedTags[i];
                break;
            }
        }
        if (typeof excludedObj === 'undefined') {
            this.addTagToExcludeList(tag);
        }
        else {
            this.removeTagFromExcludeList(tag);
        }
    };
    SimpleFilterV2Component.prototype.isTagSelected = function (tag) {
        if (this.selectedTags) {
            for (var i = 0; i < this.selectedTags.length; i++) {
                if (this.selectedTags[i] === tag) {
                    return true;
                }
            }
        }
        return false;
    };
    ;
    SimpleFilterV2Component.prototype.isTagExcluded = function (tag) {
        if (this.excludedTags) {
            for (var i = 0; i < this.excludedTags.length; i++) {
                if (this.excludedTags[i] === tag) {
                    return true;
                }
            }
        }
        return false;
    };
    ;
    return SimpleFilterV2Component;
}());
angular.module(COMPONENT_NAME, []).component("simpleFilterV2", {
    template: require("./simple-filter-v2.component.html"),
    bindings: {
        allTags: '<',
        allDropdownTags: '<',
        initState: '<',
        initExcludedFilterTags: '<',
        displayColumns: '<',
        updateFilter: '&',
        showQuery: '@?',
        showAlert: '&?',
        excludeFilter: '<'
    },
    controller: SimpleFilterV2Component
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=simple-filter-v2.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/report-options2/simple-filter-v2/simple-filter-v2.component.js